/** Nexus Protocols: timed base-wide buffs bought with Credits or Scrip (20-base.md R15). */
export interface ProtocolDef {
  id: string;
  name: { de: string; en: string };
  /** Bonus key and percent while active. */
  effect: { key: "production.all" | "build.speed" | "march.speed" | "gather.speed" | "xp.gain" | "garrison.def"; pct: number };
  /** Available durations in hours with Credit prices; the Scrip price is 50× the Credit price. */
  durations: { hours: number; credits: number }[];
}

export const NEXUS_PROTOCOLS: readonly ProtocolDef[] = [
  { id: "prt.production_25", name: { de: "Produktionsprotokoll", en: "Production Protocol" }, effect: { key: "production.all", pct: 25 }, durations: [{ hours: 8, credits: 120 }, { hours: 24, credits: 300 }] },
  { id: "prt.build_10", name: { de: "Bauprotokoll", en: "Construction Protocol" }, effect: { key: "build.speed", pct: 10 }, durations: [{ hours: 24, credits: 250 }] },
  { id: "prt.march_25", name: { de: "Marschprotokoll", en: "March Protocol" }, effect: { key: "march.speed", pct: 25 }, durations: [{ hours: 8, credits: 90 }] },
  { id: "prt.gather_50", name: { de: "Sammelprotokoll", en: "Gathering Protocol" }, effect: { key: "gather.speed", pct: 50 }, durations: [{ hours: 8, credits: 120 }] },
  { id: "prt.xp_50", name: { de: "Trainingsprotokoll", en: "Training Protocol" }, effect: { key: "xp.gain", pct: 50 }, durations: [{ hours: 24, credits: 200 }] },
  { id: "prt.defense_20", name: { de: "Verteidigungsprotokoll", en: "Defense Protocol" }, effect: { key: "garrison.def", pct: 20 }, durations: [{ hours: 24, credits: 200 }] },
];

export const PROTOCOL_SCRIP_MULTIPLIER = 50;

const protocolMap = new Map(NEXUS_PROTOCOLS.map((p) => [p.id, p]));

export function nexusProtocolById(id: string): ProtocolDef {
  const p = protocolMap.get(id);
  if (!p) throw new Error(`unknown protocol ${id}`);
  return p;
}

/** Queue rental prices in Credits (20-base.md R12). */
export const QUEUE_RENTALS: Record<"build" | "research", { period: "day" | "week" | "month"; hours: number; credits: number }[]> = {
  build: [
    { period: "day", hours: 24, credits: 300 },
    { period: "week", hours: 168, credits: 1500 },
    { period: "month", hours: 720, credits: 4500 },
  ],
  research: [
    { period: "day", hours: 24, credits: 400 },
    { period: "week", hours: 168, credits: 2000 },
    { period: "month", hours: 720, credits: 6000 },
  ],
};

/** Zone reclaim: cost scale and duration (20-base.md R13); the reclaim battle arrives with the combat sub-project. */
export const ZONE_RECLAIM: Record<string, { costMultiplier: number }> = {
  north: { costMultiplier: 1 },
  east: { costMultiplier: 2 },
  south: { costMultiplier: 4 },
  west: { costMultiplier: 8 },
};
